import React from "react";
import PropTypes from "prop-types";
import { get, chunk } from "lodash";
import { LoadMoreCollectionStories, Link } from "@quintype/components";

import NineteenStoriesOneAd from "../../rows/nineteen-stories-one-ad";

import { LoadMoreButton } from "../../atoms/read-more-link";

import { GA, WebEngage } from "../../../integrations";
import styles from "./styles.m.css";
import { DfpAd } from "../../atoms/dfp-ad";
const LOAD_MORE_TEXT = "மேலும் படிக்க";

const wrapForLoadMore = (Component, numberOfStoriesItCanAccomodate) => {
  const WrapperForLoadMore = ({ stories, collection, onLoadMore, noMoreStories, loading }) => {
    return (
      <React.Fragment>
        {chunk(stories.slice(5), numberOfStoriesItCanAccomodate).map((stories, index) => {
          const items = stories.map(story => {
            return { id: story.id, type: "story", story };
          });
          return <Component key={index} collection={{ ...collection, items }} pagetype="section" />;
        })}
        {!noMoreStories &&
          stories.length > numberOfStoriesItCanAccomodate && (
            <div className={styles["load-more-button-wrapper"]}>
              <LoadMoreButton onClick={onLoadMore} disabled={loading} text={LOAD_MORE_TEXT} />
            </div>
          )}
        <DfpAd className={`${styles["footer-ad"]} hidden-mobile`} adtype="Leaderboard" placement="section" />
      </React.Fragment>
    );
  };
  WrapperForLoadMore.propTypes = {
    stories: PropTypes.array,
    collection: PropTypes.object,
    onLoadMore: PropTypes.func,
    noMoreStories: PropTypes.func,
    loading: PropTypes.bool
  };
  return WrapperForLoadMore;
};

export class RecommendPage extends React.Component {
  componentDidMount() {
    const sections = [this.props.data.section];
    if (this.props.data.parentSection) {
      sections.unshift(this.props.data.parentSection);
    }
    GA.registerPageView(this.props.pageType, { section: this.props.data.section });
    WebEngage.registerPageView({ section: this.props.data.section });
  }

  render() {
    const stories = get(this.props.data, ["collection", "items"], []);

    if (stories.length < 1) {
      return (
        <div className={styles["default-section-page"]}>
          <div className={styles["no-stories"]}>
            <h2 className={styles["no-stories-status"]}>No stories found.</h2>
          </div>
        </div>
      );
    }

    const initialStories = get(this.props.data, ["collection", "items"], []).filter(items => items.type === "story");

    return (
      <div className={`main-page ${styles["default-section-page-container"]}`}>
        <div />
        <div className={`${styles["default-section-page"]} container`}>
          <h2 className={styles["title"]}>Recommended For You</h2>
          <div className={styles["foryou-main"]}>
            <ul className={styles["foryou-header"]}>
              <li>
                <Link aria-label="My News" href={`/my-news`} className={`${styles["link"]}`}>
                  My News
                </Link>
              </li>
              <li>
                <Link aria-label="Personalise" href={`/my-news?view=edit`} className={`${styles["link"]}`}>
                  Personalise
                </Link>
              </li>
              <li className={`${styles["active-bar"]}`}>Recommended For You</li>
            </ul>
            <LoadMoreCollectionStories
              template={wrapForLoadMore(NineteenStoriesOneAd, 19)}
              collectionSlug={this.props.data.collection.slug}
              data={Object.assign(
                {},
                { collection: this.props.data.collection },
                { stories: [...initialStories.map(({ story }) => story).slice(0, 24)] },
                { storiesPerPage: 19 }
              )}
              numStoriesToLoad={19}
              params={{ "item-type": "story" }}
            />
          </div>
        </div>
        <div />
      </div>
    );
  }
}

RecommendPage.propTypes = {
  data: PropTypes.shape({
    collection: PropTypes.object,
    section: PropTypes.shape({
      name: PropTypes.string,
      data: PropTypes.shape({
        color: PropTypes.string
      })
    }),
    parentSection: PropTypes.shape({
      name: PropTypes.string,
      data: PropTypes.shape({
        color: PropTypes.string
      })
    })
  }),
  config: PropTypes.shape({}),
  pageType: PropTypes.string
};
